module.exports = __webpack_public_path__ + "img/franciscoLopes.c55e4d09.webp";